import {
  ArrowRight,
  BookText,
  Database,
  FileCode,
  NotebookText,
  type LucideIcon,
} from "lucide-react";
import * as Routes from "routes";
import {
  Card,
  CardDescription,
  CardHeader,
  CardIcon,
  CardTitle,
} from "components/ui/card";
import { StandardPageLayout } from "@/components/layouts/standard-page-layout";

const docsActions: {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
  color: string;
}[] = [
  {
    title: "Data Documentation",
    description: "Browse the documentation for Geoscape datasets and schemas",
    href: Routes.geoscapeDocumentation,
    icon: BookText,
    color: "bg-chart-1",
  },
  {
    title: "Pre-Release Report",
    description:
      "Check out the latest pre-release report for upcoming features",
    href: Routes.docsPreRelease,
    icon: NotebookText,
    color: "bg-chart-2",
  },
  {
    title: "API Reference",
    description:
      "Explore the API reference for Geoscape's APIs and integrations",
    href: Routes.docsApi,
    icon: FileCode,
    color: "bg-chart-3",
  },
];

export const DocsPage = () => {
  return (
    <StandardPageLayout
      pageTitle={{
        icon: Database,
        title: "Geoscape Documentation",
        description:
          "Find all the resources you need to understand and use Geoscape effectively",
      }}
    >
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {docsActions.map((action) => (
          <a
            key={action.title}
            href={action.href}
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline"
          >
            <Card className="group relative overflow-hidden bg-card hover:bg-muted cursor-pointer h-full">
              <CardHeader>
                <CardIcon
                  variant="top"
                  className={`${action.color} text-background p-2.5 rounded-lg`}
                >
                  <action.icon className="size-5" />
                </CardIcon>
                <CardTitle>{action.title}</CardTitle>
                <CardDescription>{action.description}</CardDescription>
                <ArrowRight className="absolute bottom-4 right-4 size-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
              </CardHeader>
            </Card>
          </a>
        ))}
      </div>
    </StandardPageLayout>
  );
};
